<template>
    <row class="relative overflow-x-hidden" justify="center">
        <background-colored-sections></background-colored-sections>
        <absolute-svgs @load="initAnimations()"></absolute-svgs>
        <overlay v-model="showVideoOverlay">
            <row align="center" class="h-full relative" justify="center">
                <video-player :play="showVideoOverlay" :src="homePageVideoSrc" class="absolute" controls="fixed"
                              max-width="1000px"
                ></video-player>
            </row>
        </overlay>
        <overlay :close-button-offset-y="innerWidth <= 599 ? '45' : '55'" close-button-offset-x="30"
                 v-model="showMobileMenuOverlay">
            <mobile-menu></mobile-menu>
        </overlay>
        <column class="home-page-padding relative xs:overflow-x-hidden" style="max-width: 1920px; width: 100%;">
            <parallax-shapes-home></parallax-shapes-home>
            <!--                    Absolute elements/-->
            <!--                Navbar-->
            <img class="absolute home-page-main-logo" src="@/assets/logos/fitt_light.png">
            <btn @click="showMobileMenuOverlay = true"
                 class="absolute nav-menu"
                 icon
                 v-show="!showMobileMenuOverlay"
            >
                <icon color="white" icon="menu"></icon>
            </btn>
            <row class="absolute text-white nav-bar" justify="space-between"
                 style="top: 72px; height: 20px; width: 750px;">
                <tw-menu bottom>
                    <template v-slot:activator="{ on }">
                        <btn :ripple="false" class="poppins-bold tracking-wide leading-tight" flat height="20"
                             no-padding
                             tile v-on="on">
                            Why Fitt?
                        </btn>
                    </template>
                    <tw-list class="px-6">
                        <tw-list-item

                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/customizations"
                            >Customizations
                            </router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/dispersing-notions"
                            >Dispersing Notions
                            </router-link>
                        </tw-list-item>
                        <!--                        <tw-list-item-->
                        <!--                            @click="goToUseCases()"-->
                        <!--                            class="tracking-normal leading-relaxed poppins-medium"-->
                        <!--                        >-->
                        <!--                            Use cases-->
                        <!--                        </tw-list-item>-->
                        <!--                        <tw-list-item-->
                        <!--                            class="tracking-normal leading-relaxed poppins-medium"-->
                        <!--                        >-->
                        <!--                            <router-link to="/cambridge" active-class="text-primary">Cambridge</router-link>-->
                        <!--                        </tw-list-item>-->
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/university-of-cambridge"
                            >Cambridge
                            </router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/languages"
                            >Languages
                            </router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/reporting"
                            >Reporting
                            </router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/applications"
                            >Applications
                            </router-link>
                        </tw-list-item>
                    </tw-list>
                </tw-menu>
                <!--                <btn flat :ripple="false" class="poppins-bold tracking-wide leading-tight" no-padding tile height="20">-->
                <!--                    Platform-->
                <!--                </btn>-->
                <!--                <btn flat :ripple="false" class="poppins-bold tracking-wide leading-tight" no-padding tile height="20">-->
                <!--                    Pricing-->
                <!--                </btn>-->
<!--                <router-link to="/case-studies" class="poppins-bold tracking-wide leading-tight text-white"></router-link>-->
                <btn :ripple="false"
                     class="poppins-bold tracking-wide leading-tight"
                     flat
                     height="20"
                     no-padding
                     tile
                     @click="$router.push('/case-studies')"
                >Case Studies
                </btn>
                <btn :ripple="false"
                     class="poppins-bold tracking-wide leading-tight"
                     flat
                     height="20"
                     no-padding
                     tile
                     @click="$router.push('/get-fitt')"
                >Get Fitt
                </btn>
                <!--                <btn flat :ripple="false" class="poppins-bold tracking-wide leading-tight" no-padding tile height="20">-->
                <!--                    Get Fitt-->
                <!--                </btn>-->
<!--                <btn :ripple="false" @click="$navigate('https://manage.fitt.ai/')"-->
<!--                     class="poppins-bold tracking-wide leading-tight" flat height="20" no-padding-->
<!--                     tile>-->
<!--                    Log In-->
<!--                </btn>-->
                <btn :ripple="false" @click="$navigate('/ebook')"
                     class="poppins-bold tracking-wide leading-tight" flat height="20" no-padding
                     tile>
                    EBOOK
                </btn>
                <btn :ripple="false" @click="$navigate('https://journey.fitt.ai/')"
                     class="poppins-bold tracking-wide leading-tight" flat height="20" no-padding
                     tile>
                    Completing a Fitt?
                </btn>
            </row>
            <!--                    End of absolute elements-->
            <row class="home-page-main">
                <column cols="full">
                    <row class="text-white">
                        <column xs="full">
                            <divider class="xs:mb-6 sm:mb-10" width="62px"></divider>
                            <div class="tracking-widest poppins-bold">WELCOME TO FITT</div>
                            <p class="xs:mt-4 sm:mt-5 xs:mb-6 sm:mb-10 poppins-semibold tracking-normal xs:leading-higher sm:leading-highest xs:text-4xl sm:text-7xl">
                                fitt is the fully
                                <br>
                                integrated talent
                                <br>
                                platform
                            </p>
                            <div
                                class="text-left xs:text-xl sm:text-2xl tracking-normal xs:leading-tight sm:leading-relaxed xs:max-w-sm sm:max-w-2xl">
                                Following a multi-method approach, to deliver predictive
                                people analytics. Extrapolated across domains,
                                for data
                                driven development and assessment.
                            </div>
                            <div
                                class="uppercase xs:mt-6 sm:mt-10 xs:mb-8 sm:mb-12 xs:tracking-wider sm:tracking-widest poppins-bold leading-tight xs:w-8/12">
                                digital enterprise solution. experience. analytics
                            </div>
                            <btn @click="showVideoOverlay = true" class="tracking-widest poppins-bold" color="white"
                                 height="75" no-padding
                                 outlined style="padding: 7px;" width="278">
                                <btn color="white" fab size="61">
                                    <icon color="primary" icon="play"></icon>
                                </btn>
                                <!--                                Hard code font-size. Mobile and desktop should be equal-->
                                <div class="px-5" style="font-size: 14px;">
                                    PLAY VIDEO
                                </div>
                            </btn>
                        </column>
                        <!--                        Main svg for mobile/-->
                        <column class="sm:hidden -mb-32" xs="full">
                            <object
                                :data="mainSvg"
                                class="transform -translate-y-20 translate-x-12 pointer-events-none"
                                id="main_svg_mobile"
                                style="max-width: 368px;"
                                type="image/svg+xml"
                                @load="initMainSvgAnimations($event)"
                            ></object>
                        </column>
                    </row>
                </column>
            </row>
            <row justify="center">
                <divider class="xs:mb-6 sm:mb-8" color="primary" width="56"></divider>
                <column align="center"
                        class="text-center xs:mb-1 sm:mb-3 text-secondary poppins-bold tracking-normal xs:leading-loose sm:leading-higher xs:text-3xl sm:text-5xl"
                        cols="full">
                    A fully virtual assessment &
                    <br>
                    development center
                </column>
                <column align="center"
                        class="text-center poppins-bold text-primary uppercase tracking-widest mt-6"
                        cols="full"
                >
                    EXPONENTIAL TECHNOLOGY . EXPONENTIAL EXPERIENCE
                </column>
            </row>
            <virtual-assessment class="mt-16"></virtual-assessment>
            <why-fitt class="xs:mt-32 sm:mt-24 lg:mt-32 xl:mt-60"></why-fitt>
            <cambridge class="xs:mt-32 sm:mt-48"></cambridge>
            <fitt-framework class="xs:mt-32 sm:mt-40"></fitt-framework>
            <customization class="xs:mt-32 sm:mt-56"></customization>
            <applications :applications="[
                                        'Career<br>Planning',
                                        'Leadership<br>Development',
                                        'Workforce and<br>Succession Planning',
                                        'Talent<br>Management',
                                        'Employee<br>Experience',
                                        'Recruitment',
                                        'Selection and<br>Promotion',
                                        'Training<br>Needs Analysis',
                                        'Strategic<br>People Analytics',
                                        'Culture and<br>Engagement'
                                    ]"
                          class="xs:mt-40 sm:mt-56"
            ></applications>
            <fitt-value-drivers class="xs:mt-40 sm:mt-48"></fitt-value-drivers>
            <user-groups class="xs:mt-40 sm:mt-56"></user-groups>
            <talent-pager :talents="[
                 'Signature <br> strengths',
                 'Development <br> Areas',
                 'Engagement <br> Drivers',
                 'Work <br> Personality',
                 'Leadership <br> Style and Risks',
                 'Work <br> Well-Being',
                 'Risk <br> Propensity',
                 'Trend Data and <br> Analytics'
            ]"
                          class="mt-56"
            ></talent-pager>
            <current-clients :clients="[
                                 {
                                     src: 'stc.png',
                                     size: '50'
                                 },
                                 {
                                     src: 'maaden.png',
                                     size: '60'
                                 },
                                 {
                                     src: 'sec.png',
                                     size: '60'
                                 },
                                 // {
                                 //     src: 'pwc.png',
                                 //     size: '60'
                                 // },
                                 {
                                     src: 'kpmg.png',
                                     size: '45'
                                 },
                                 {
                                     src:  'wood.png',
                                     size: '35'
                                 },
                                 {
                                     src:  'ghc.png',
                                     size: '55'
                                 },
                                 {
                                     src:  'medihelp.png',
                                     size: '55'
                                 },
                                 {
                                     src:  'dussur.png',
                                     size: '55'
                                 },
                                 {
                                     src:  'slg.png',
                                     size: '55'
                                 },
                                 {
                                     src:  'meridian.png',
                                     size: '60'
                                 },
                                 {
                                     src:  'qatar.png',
                                     size: '75'
                                 },
                                 {
                                     src:  'santam.png',
                                     size: '45'
                                 },
                                 {
                                     src:  'distell.png',
                                     size: '60'
                                 },
                                 {
                                     src:  'famousbrands.png',
                                     size: '45'
                                 },
                                 {
                                     src:  'qafco.png',
                                     size: '60'
                                 },
                                 {
                                     src:  'bank_aljazira.png',
                                     size: '40'
                                 },
                                 {
                                     src:  'acwa_power.png',
                                     size: '50'
                                 },
                             ]"
                             class="mt-12"
            ></current-clients>
        </column>
        <website-footer class="mt-24"></website-footer>
    </row>
</template>

<script>
    import anime from 'animejs';
    import AnimateMainSvg from "../mixins/AnimateMainSvg";

    export default {
        name: 'Home',
        mixins: [AnimateMainSvg],
        components: {
            'background-colored-sections': () => import('@/components/page/BackgroundColoredSections.vue'),
            'absolute-svgs': () => import('@/components/page/AbsoluteSvgs.vue'),
            'icon': () => import('@/components/display/Icon.vue'),
            'parallax-shapes-home': () => import('@/components/display/ParallaxShapesHome.vue'),
            'tw-menu': () => import('@/components/display/TwMenu.vue'),
            'tw-list': () => import('@/components/List.vue'),
            'tw-list-item': () => import('@/components/ListItem.vue'),
            'divider': () => import('@/components/Divider.vue'),
            'btn': () => import('@/components/Btn.vue'),
            'virtual-assessment': () => import('@/components/page/VirtualAssessment.vue'),
            'why-fitt': () => import('@/components/page/WhyFitt.vue'),
            'cambridge': () => import('@/components/page/Cambridge.vue'),
            'fitt-framework': () => import('@/components/page/FittFramework.vue'),
            'customization': () => import('@/components/page/Customization.vue'),
            'applications': () => import('@/components/page/Applications.vue'),
            'fitt-value-drivers': () => import('@/components/page/FittValueDrivers.vue'),
            'user-groups': () => import('@/components/page/UserGroups.vue'),
            'talent-pager': () => import('@/components/page/TalentPager.vue'),
            'current-clients': () => import('@/components/page/CurrentClients.vue'),
            'website-footer': () => import('@/components/page/WebsiteFooter.vue'),
            'mobile-menu': () => import('@/components/page/MobileMenu.vue'),
            'overlay': () => import('@/components/Overlay.vue'),
            'video-player': () => import('@/components/display/VideoPlayer.vue'),
        },
        data: () => ({
            homePageVideoSrc: null,
            showVideoOverlay: false,
            showMobileMenuOverlay: false,
            innerWidth: 0
        }),
        computed: {
            mainSvg() {
                return require('@/assets/images/homepage/homepage_main.svg');
            },
        },
        methods: {
            getElement(main, id) {
                return main.contentDocument.querySelector(id);
            },
            setInitialPosition(target, x, y) {
                anime({targets: target, translateX: x, translateY: y, duration: 0});
            },
            initAnimations() {
                let main_symbols = this.$el.querySelector('#main_symbols'),
                    circles = {
                        circle_1: this.getElement(main_symbols, '#Ellipse_1'),
                        circle_2: this.getElement(main_symbols, '#Ellipse_2'),
                        circle_3: this.getElement(main_symbols, '#Ellipse_3'),
                        circle_4: this.getElement(main_symbols, '#Ellipse_4'),
                        circle_5: this.getElement(main_symbols, '#Ellipse_5'),
                        circle_9: this.getElement(main_symbols, '#Ellipse_9')
                    };
                // main_svg = this.$el.querySelector('#main_svg'),
                // bar = {
                //     line_2: this.getElement(main_svg, '#Path_25'),
                // };
                this.setInitialPosition(circles.circle_1, 836, 451);
                this.setInitialPosition(circles.circle_2, 1094, 231);
                this.setInitialPosition(circles.circle_3, 1015, 738);
                this.setInitialPosition(circles.circle_4, 51, 540);
                this.setInitialPosition(circles.circle_5, -71, 569);
                this.setInitialPosition(circles.circle_9, 1120, 214);
                // this.setInitialPosition(bar.line_2, -82.083, -88.299);
                this.animateCircle(circles.circle_1, 636, 1036, 251, 651);
                this.animateCircle(circles.circle_2, 894, 1294, 31, 431);
                this.animateCircle(circles.circle_3, 815, 1215, 538, 938);
                this.animateCircle(circles.circle_4, -149, 251, 340, 740);
                this.animateCircle(circles.circle_5, -271, 129, 369, 769);
                this.animateCircle(circles.circle_9, 920, 1320, 14, 414);
                // this.animateBar(bar.line_2);
                setInterval(() => {
                    this.animateCircle(circles.circle_1, 636, 1036, 251, 651);
                    this.animateCircle(circles.circle_2, 894, 1294, 31, 431);
                    this.animateCircle(circles.circle_3, 815, 1215, 538, 938);
                    this.animateCircle(circles.circle_4, -149, 251, 340, 740);
                    this.animateCircle(circles.circle_5, -271, 129, 369, 769);
                    this.animateCircle(circles.circle_9, 920, 1320, 14, 414);
                }, 30000)
            },
            animateCircle(target, xMin, xMax, yMin, yMax) {
                anime({
                    targets: target,
                    keyframes: [
                        {
                            translateX: function () {
                                return anime.random(xMin, xMax);
                            },
                            translateY: function () {
                                return anime.random(yMin, yMax);
                            },
                        }
                    ],
                    easing: 'easeInOutQuad',
                    duration: 30000
                });
            },
            fetchVideo() {
                this.$contentful.getAsset('20kjRbMDXBS1OD9Ihsm8CR')
                    .then((asset) => {
                        this.homePageVideoSrc = 'https:' + asset.fields.file.url;
                    })
                    .catch(console.error)
            },
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
            },
            initMainSvgAnimations(event) {
                this.animateHorizontalBars(event.target);
                this.animateVerticalBars(event.target);
            }
        },
        mounted() {
            this.fetchVideo();
            window.addEventListener('resize', this.setInnerWidth);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style>
    /*Mobile*/
    @media only screen and (max-width: 599px) {
        .nav-menu {
            top: 45px;
            /*left: 0px;*/
        }

        .home-page-main {
            /*    Divider above welcome to fitt position*/
            padding-top: 167px;
        }

        .home-page-main-logo {
            top: 35px;
            left: 0px;
            width: 150px;
        }
    }

    /*Tablet and desktops*/
    /*600 = nexus 7*/
    @media only screen and (min-width: 600px) {
        .nav-menu {
            top: 55px;
            /*left: 30px;*/
        }

        .home-page-main-logo {
            top: 35px;
            left: 45px;
            width: 210px;
        }

        .home-page-main {
            /*Full virtual divider y-position*/
            height: 1079px;
            /*    Divider above welcome to fitt position*/
            padding-top: 208px;
        }
    }

    /*Nav bar*/
    @media only screen and (max-width: 1024px) {
        .nav-bar {
            display: none;
        }

        .home-page-main-logo {
            left: 70px;
            width: 200px;
        }
    }

    @media only screen and (min-width: 1025px) {
        .nav-menu {
            display: none;
        }

        .nav-bar {
            left: 359px;
        }
    }

    /*Main svg*/
    @media only screen and (max-width: 1600px) {
        .home-page-main-svg {
            transform: translateX(-100px);
        }
    }

    @media only screen and (max-width: 1500px) {
        .home-page-main-svg {
            transform: translateX(-220px) translateY(100px);
            max-width: 650px !important;
        }
    }

    @media only screen and (max-width: 1300px) {
        .home-page-main-svg {
            transform: translateX(-280px) translateY(150px);
            max-width: 600px !important;
        }
    }

    @media only screen and (max-width: 1200px) {
        .home-page-main-svg {
            transform: translateX(-250px) translateY(200px);
            max-width: 500px !important;
        }
    }

    @media only screen and (max-width: 1100px) {
        .home-page-main-svg {
            transform: translateX(-420px) translateY(300px);
            max-width: 450px !important;
        }
    }

    @media only screen and (max-width: 900px) {
        .home-page-main-svg {
            transform: translateX(-500px) translateY(300px);
            max-width: 400px !important;
        }
    }

    @media only screen and (max-width: 800px) {
        .home-page-main-svg {
            transform: translateX(-620px) translateY(300px);
            max-width: 400px !important;
        }
    }

    @media only screen and (min-width: 1025px) and (max-width: 1639px) {
        /*8.5 rem = reduction in padding for screens below 1500px width*/
        .home-page-main-logo {
            left: calc(15px);
        }

        .nav-bar {
            left: calc(359px - 8.5rem);
        }
    }

    /*Global padding, main symbols svg/*/
    /*@media only screen and (max-width: 1500px) {*/
    @media only screen and (max-width: 1639px) {
        .home-page-padding {
            /*sm:px-40 xs:px-6*/
            padding: 0 1.5rem;
        }

        /*8.5 rem = reduction in padding for screens below 1500px width*/
        .home-page-main-symbols {
            left: calc(-71px - 8.5rem);
        }
    }

    @media only screen and (min-width: 1640px) {
        /*@media only screen and (min-width: 1501px) {*/
        .home-page-padding {
            padding: 0 10rem;
        }

        .home-page-main-symbols {
            left: -71px;
        }
    }
</style>
